import { request } from "apis/base";
import { NotificationParamsType } from "constants/types/notification";

export const notificationApi = {
  getAll: (params?: NotificationParamsType) => {
    return request({ url: "/notification", method: "GET", params });
  },

  getUnreadCount: () => {
    return request({ url: "/notification/unread-count", method: "GET" });
  },

  markOneRead: (id: string) => {
    return request({ url: `/notification/${id}/read`, method: "PATCH" });
  },

  markAllRead: () => {
    return request({ url: "/notification/read-all", method: "PATCH" });
  },
};
